// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

    /*
     * Header API: Dados gerais de identificação da rota principal
     *  - É necessário utilizar o token da entidade
     *  - Definir qual o sistema que esta consumindo as APIs
     */
    urlApi: 'https://apiteste.tennistool.tenisintegrado.com/',
    //urlApi: 'http://localhost/tennistoolapi/',
    // urlApi: 'http://localhost:8000/',
    identifySystem: '2',

    googleAPIKey: 'AIzaSyCyKsD93pgDGV3FTia70GCZqso-MxdaTww',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *ccyy
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
